import React, { Fragment, useEffect, useState, useMemo } from 'react';
import { Box, Grid, Typography, IconButton, Divider } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { FontFamily } from 'assets';
import Colors from 'assets/Style/Colors';
import { ErrorToaster, SuccessToaster } from 'components/Toaster';
import { useForm } from "react-hook-form";
import SelectField from "components/Select";
import { Add } from "@mui/icons-material";
import CustomerServices from 'services/Customer';
import { PrimaryButton } from 'components/Buttons';
import AuctionHouseServices from "services/AuctionHouse";

function BuyerIdAllocation() {
    const { id } = useParams();
    const navigate = useNavigate();
    const state = React.useMemo(() => {
        try {
            const raw = localStorage.getItem("buyerIdAllocationData");
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    }, []);


    console.log(id);

    console.log(state, 'state')

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        resetField,
        control,
    } = useForm();

    const [allocatedBuyers, setAllocatedBuyers] = useState([]);
    const [selectedBuyers, setSelectedBuyers] = useState([]);
    const [isNewBuyer, setIsNewBuyer] = useState(false);

    const [auctionHouses, setAuctionHouses] = useState([]);
    const [buyerIds, setBuyerIds] = useState([]);
    const [buyerOptionsByAuction, setBuyerOptionsByAuction] = useState({});
    const [selectedAuctionHouses, setSelectedAuctionHouses] = useState([]);
    const [selectedBuyerIds, setSelectedBuyerIds] = useState([]);
    const [allocateLoading, setAllocateLoading] = useState(false);
    const [buyerTypes, setBuyerTypes] = useState({});
    console.log(buyerTypes, 'buyerTypes')

    console.log(buyerIds, 'buyerIds options');
    console.log(auctionHouses, 'auctionHouses options')

    const [prevAllocated, setPrevAllocated] = useState([]);
    const [prevAllocatedIds, setPrevAllocatedIds] = useState([]);
    const [requestedDeAllocations, setRequestedDeAllocations] = useState([]);

    console.log(selectedBuyerIds, 'selectedBuyerIds')
    console.log(prevAllocated, 'prevAllocated')
    console.log(requestedDeAllocations, 'requestedDeAllocations')

    const [unlinkedAuctionIds, setUnlinkedAuctionIds] = useState([]);
    console.log(unlinkedAuctionIds, 'unlinkedAuctionIds')

    const getDetailIdByAuction = (auctionId) => {
        const match = state?.request?.details?.find(
            d => (d?.auction?.id ?? d?.auction_id) === auctionId
        );
        return match?.id ?? null;
    };


    useEffect(() => {
        const details = state?.request?.details ?? [];

        const groupedBuyers = {};

        details.forEach(d => {
            const auction_id = d?.auction?.id ?? d?.auction_id;
            const auction_house = d?.auction?.name ?? d?.auction_house;
            const detail_id = d?.id;
            const allocated = Array.isArray(d?.allocated) ? d.allocated : [];

            if (allocated.length > 0) {
                if (!groupedBuyers[auction_id]) {
                    groupedBuyers[auction_id] = {
                        auction_house,
                        detail_id,
                        buyers: [],
                    };
                }

                allocated.forEach((a) => {
                    groupedBuyers[auction_id].buyers.push({
                        id: a?.buyer_id,
                        name: a?.buyer?.name,
                        buyer: a?.buyer,
                        type: a?.buyer?.type,
                        auction_id,
                        auction_house,
                        detail_id
                    });
                });
            }
        });

        const groupedData = Object.values(groupedBuyers);
        setAllocatedBuyers(groupedData);
        setPrevAllocated(groupedData);
        setPrevAllocatedIds(groupedData.flatMap(group => group.buyers.map(b => b.buyer_id)));

        const auctionHouseSelections = groupedData.map(group => ({
            id: group?.buyers?.[0]?.auction_id,
            name: group.auction_house
        }));

        const buyerSelections = groupedData.map(group => group.buyers);

        setSelectedAuctionHouses(auctionHouseSelections);
        setSelectedBuyerIds(buyerSelections);

        const types = {};
        auctionHouseSelections.forEach((auction) => {
            types[auction.id] = {};
        });
        setBuyerTypes(types);
    }, [state]);


    const flattenPrevAllocated = () => {
        const flattened = [];

        prevAllocated.forEach((auction) => {
            auction.buyers.forEach((buyer) => {
                flattened.push({
                    auction_id: buyer.auction_id,
                    auction_house: auction?.auction_house,
                    id: buyer.id,
                    name: buyer.name,
                    detail_id: auction.detail_id,
                });
            });
        });

        return flattened;
    };

    const flattenCurrentSelections = () => {
        const rows = [];

        selectedAuctionHouses.forEach((ah, idx) => {
            if (!ah) return;

            const buyers = Array.isArray(selectedBuyerIds[idx]) ? selectedBuyerIds[idx] : [];

            const prevAllocatedFlattened = flattenPrevAllocated();

            buyers.forEach((b) => {
                const isAlreadyAllocated = prevAllocatedFlattened.some(
                    (p) => p.auction_id === ah.id && p.id === b.id
                );
                if (!isAlreadyAllocated) {
                    rows.push({
                        auction_id: ah.id,
                        auction_house: ah.name,
                        buyer_id: b.id,
                        buyer_name: b.name,
                        detail_id: getDetailIdByAuction(ah.id),
                        // detail_id: state?.request?.details?.find(detail => detail?.auction_id === ah?.id)?.id || null,
                        isAllocated: false,
                    });
                }
            });
        });

        return rows;
    };


    const getBuyerId = async (auctionHouseId = '', search = '') => {
        console.log('Getting buyers for auction house:', auctionHouseId);
        try {
            let typeId;
            if (state?.customerProfile?.type?.id === 1) {
                typeId = 'A';
            } else if (state?.customerProfile?.type?.id === 2) {
                typeId = 'B';
            } else if (state?.customerProfile?.type?.id === 3) {
                typeId = 'C';
            }

            let params = {
                auction_ids: auctionHouseId,
                type: typeId,
            };

            console.log('API Request params:', params);

            const { data } = await CustomerServices.getBuyerIdByAuctionId(params);
            console.log('API Response:', data);

            if (data) {
                let allBuyers = Array.isArray(data?.details?.[0]?.buyer_ids) ? data?.details?.[0]?.buyer_ids : [];
                const filtered = auctionHouseId
                    ? allBuyers.filter((b) => b?.auction_house_id === auctionHouseId)
                    : allBuyers;

                // setBuyerIds(filtered);

                setBuyerOptionsByAuction((prev) => ({
                    ...prev,
                    [auctionHouseId]: filtered,
                }));
            }
        } catch (error) {
            console.error('Error fetching buyers:', error);
            ErrorToaster(error);
        }
    };


    const getAuctionHouses = async (search) => {
        try {
            let params = {
                page: 1,
                limit: 50,
                search: search
            };
            const { data } = await AuctionHouseServices.getAuctionHouses(params);
            setAuctionHouses(Array.isArray(data?.auction_houses?.rows) ? data?.auction_houses?.rows : []);
        } catch (error) {
            ErrorToaster(error);
        }
    };


    const onSubmit = async () => {

        if (state?.name !== 'UNKNOWN') {
            for (let i = 0; i < selectedAuctionHouses.length; i++) {
                const selectedBuyers = selectedBuyerIds[i];
                const buyerTypesCount = selectedBuyers.reduce((acc, { type }) => {
                    acc[type] = (acc[type] || 0) + 1;
                    return acc;
                }, {});

                const exceededBuyerTypes = Object.values(buyerTypesCount).some(count => count > 2);
                if (exceededBuyerTypes) {
                    ErrorToaster(`You cannot select more than two buyers of the same type for auction house: ${selectedAuctionHouses[i]?.name}`);
                    return;
                }
            }

        }

        try {
            const current = flattenCurrentSelections();

            const requested_allocations = current;

            const currentKey = new Set(current.map((c) => `${c.auction_id}:${c.buyer_id}`));

            const allocations = prevAllocated
                .flatMap((auction) => auction.buyers)
                .filter((p) => !currentKey.has(`${p.auction_id}:${p.buyer_id}`))
                .map((p) => ({
                    auction_id: p.auction_id,
                    buyer_id: p.id,
                    buyer_name: p.name,
                    detail_id: p.detail_id,
                    auction_house: p.auction_house,
                }));


            const payload = {
                requested_allocations,
                requested_deAllocations: requestedDeAllocations,
                allocations,
                request_id: state?.request?.id,
                customer_id: state?.id,
                customer_name: state?.name,
                customer_phone: state?.uae_phone,
                auction_houses: unlinkedAuctionIds,
            };

            setAllocateLoading(true);
            const { message } = await CustomerServices.allocateBuyerId(payload);
            navigate('/customer-queue')
            SuccessToaster('Buyer ID Status has been Updated');
        } catch (error) {
            ErrorToaster(error);
        } finally {
            setAllocateLoading(false);
        }
    };

    const handleRemoveBuyer = (ahIndex, buyerId, buyerName, detailId) => {
        const updatedBuyerIds = [...selectedBuyerIds];
        updatedBuyerIds[ahIndex] = (updatedBuyerIds[ahIndex] || []).filter(b => b.id !== buyerId);
        setSelectedBuyerIds(updatedBuyerIds);

        const wasPreviouslyAllocated = flattenPrevAllocated().some(
            p => p.auction_id === selectedAuctionHouses[ahIndex]?.id && p.id === buyerId
        );

        if (wasPreviouslyAllocated) {
            const removedBuyer = {
                auction_id: selectedAuctionHouses[ahIndex]?.id,
                auction_house: selectedAuctionHouses[ahIndex]?.name,
                buyer_id: buyerId,
                buyer_name: buyerName,
                detail_id: detailId ?? getDetailIdByAuction(selectedAuctionHouses[ahIndex]?.id) ?? null,
            };
            setRequestedDeAllocations(prev => [...prev, removedBuyer]);
        }
    };


    const handleAddAuctionHouse = () => {
        setSelectedAuctionHouses([...selectedAuctionHouses, null]);
        setSelectedBuyerIds([...selectedBuyerIds, []]);

        getAuctionHouses();
    };

    const handleAuctionHouseSelect = (index, value) => {
        console.log(value?.id, value, 'selected auction house');
        const updatedAuctionHouses = [...selectedAuctionHouses];
        updatedAuctionHouses[index] = value;
        setSelectedAuctionHouses(updatedAuctionHouses);
        setSelectedBuyerIds((prev) => {
            const copy = [...prev];
            copy[index] = [];
            return copy;
        });

        const detailId = getDetailIdByAuction(value?.id);
        if (!detailId) {
            setUnlinkedAuctionIds(prev => Array.from(new Set([...(prev ?? []), value?.id])));
        } else {
            setUnlinkedAuctionIds(prev => (prev ?? []).filter(id => id !== value?.id));
        }

        getBuyerId(value?.id);
    };



    const handleBuyerIdSelect = (index, value) => {
        const updatedBuyerIds = [...selectedBuyerIds];
        updatedBuyerIds[index] = value;
        setSelectedBuyerIds(updatedBuyerIds);
    };

    // const getAvailableAuctionHouses = (index) => {
    //     return auctionHouses.filter(
    //         (auctionHouse) => !selectedAuctionHouses.slice(0, index).some((selected) => selected?.id === auctionHouse.id)
    //     );
    // };

    const getAvailableAuctionHouses = (index) => {
  const alreadyChosenAbove = new Set(
    selectedAuctionHouses.slice(0, index).map(s => s?.id).filter(Boolean)
  );

  return auctionHouses.map(ah => ({
    ...ah,
    disabled: prevAllocatedAuctionIds.has(ah.id) || alreadyChosenAbove.has(ah.id),
  }));
};

const prevAllocatedAuctionIds = useMemo(() => {
  const ids = new Set();
  prevAllocated.forEach(group => {
    group.buyers.forEach(b => {
      if (b?.auction_id != null) ids.add(b.auction_id);
    });
  });
  return ids;
}, [prevAllocated]);

const isPrevAllocatedRow = (index) => {
  const ah = selectedAuctionHouses[index];
  return !!ah && prevAllocatedAuctionIds.has(ah.id);
};


    useEffect(() => {
        getAuctionHouses();
        // getBuyerId();
    }, []);

    return (
        <Box sx={{ m: 4, p: 5, bgcolor: Colors.white, borderRadius: 3, boxShadow: '0px 8px 18px 0px #9B9B9B1A' }}>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={8}>
                    <Typography variant="h5" sx={{ color: Colors.charcoalGrey, fontFamily: FontFamily.NunitoRegular, mb: 4 }}>
                        Buyer Id Allocation
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={4} sx={{ textAlign: 'right' }}>
                    <PrimaryButton
                        title={"Add Auction House"}
                        startIcon={<Add sx={{ color: Colors.white }} />}
                        onClick={handleAddAuctionHouse}
                    />
                </Grid>
            </Grid>
            {selectedAuctionHouses.map((_, index) => (
                <Fragment key={index}>
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                        <Grid item xs={12} sm={4}>
                            <SelectField
                                onSearch={(v) => getAuctionHouses(v)}
                                label={'Auction Houses'}
                                options={getAvailableAuctionHouses(index)}
                                selected={selectedAuctionHouses[index]}
                                onSelect={(value) => handleAuctionHouseSelect(index, value)}
                                error={errors?.auctionHouses?.message}
                                register={register(`auctionHouses[${index}]`, {
                                    required: 'Please select auction house.',
                                })}
                                getOptionDisabled={(option) => !!option?.disabled}
                                 disabled={isPrevAllocatedRow(index)}  
                            />
                        </Grid>

                        {selectedAuctionHouses[index] && (
                            <Grid item xs={12} sm={6}>
                                <SelectField
                                    size='small'
                                    label={'Buyer ID'}
                                    options={
                                        buyerOptionsByAuction[selectedAuctionHouses[index]?.id]
                                            ? buyerOptionsByAuction[selectedAuctionHouses[index]?.id]
                                            : []
                                    }
                                    // options={Array.isArray(buyerIds) ? buyerIds : []}
                                    selected={selectedBuyerIds[index]}
                                    onSearch={(v) => getBuyerId(selectedAuctionHouses[index]?.id, v)}
                                    onSelect={(value) => handleBuyerIdSelect(index, value)}
                                    error={errors?.buyerId2?.message}
                                    register={register(`buyerId[${index}]`, {})}
                                    multiline={true}
                                    isMultiSelect
                                    multiple={true}
                                    renderTags={false}
                                />
                            </Grid>
                        )}
                    </Grid>
                    <Box
                        key={index}
                        sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            pr: 0.5,
                            pt: 1.5,
                            pb: 1.5,
                            borderRadius: "8px",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            width: "100%",
                            boxSizing: "border-box",
                            '@media (max-width: 600px)': {
                                width: "100%",
                            }
                        }}
                    >
                        {
                            selectedBuyerIds?.[index]?.map((item, idx) => {
                                return (
                                    <Box
                                        key={idx}
                                        sx={{
                                            backgroundColor: "#F5F5F5",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            boxSizing: "border-box",
                                            border: "1px solid #F5F5F5",
                                            padding: "8px",
                                            borderRadius: "8px",
                                            gap: "5px",
                                            m: 0.5,
                                            width: "auto",
                                            maxWidth: "100%",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                marginTop: "2px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                        >
                                            {item?.buyer_name ? item?.buyer_name : item?.name} -{" "}
                                            {item?.buyer?.type ? item?.buyer?.type : item?.type}
                                        </Typography>
                                        <IconButton
                                            onClick={() => handleRemoveBuyer(index, item?.id, item?.name, item?.detail_id)}
                                            sx={{ color: "red", p: "2px" }}
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                );
                            })
                        }
                    </Box>


                    {index !== selectedAuctionHouses.length - 1 && <Divider sx={{ my: 2 }} />}
                </Fragment>

            ))}

            {
                selectedAuctionHouses.length > 0 && (
                    <Grid item xs={12} sm={12} sx={{ mt: 2, textAlign: 'right' }}>
                        <PrimaryButton title="Submit" onClick={onSubmit} />
                    </Grid>
                )
            }


        </Box>
    );
}

export default BuyerIdAllocation;
